import { defineMessages } from "react-intl";

const PREFIX = "AccountBar";
export default defineMessages({
  loggedInAs: {
    id: `${PREFIX}.loggedInAs`,
    defaultMessage: "Logged in as",
  },
});
